import { makeStyles } from "@material-ui/core/styles"

export const useCalendarDateLabelStyle = makeStyles(() => ({
    header: {
        display: "flex",
        width: "100%",
    },
    label: {
        width : "130px",
        padding: "2px 4px",
    },
    content: {
        borderLeft: "1px solid #ddd",
        display: "flex",
        flexGrow: 1,
        FlexDirection: "column",
    },
    timeLabel: {
        width: "100%",
        textAlign: "center",
        fontWeight: "bold",
    },
    timeLabelPos: {
        width: 200,
        flexShrink: 0,
        textAlign: "center",
        fontSize: 18,
    },
    input: {
        display: "flex",
        width: "100%",
        marginTop: 10,
        height: 35,
        paddingLeft: 4,
        borderTop: "1px solid #ddd",
        alignItems: "center",
        justifyContent: "center",
        "& span": {
            whiteSpace: "nowrap",
        },
    },
}))
